// Static content for the webinar landing page.
// Co-hosts: George Tabora & Claudia Gomez — American Pacific Mortgage.

export const HOSTS = [
  {
    name: "George Tabora",
    title: "Loan Officer, American Pacific Mortgage",
    nmls: "NMLS #2049966",
    image:
      "https://customer-assets.emergentagent.com/job_realtor-learning-hub/artifacts/c9dx4nhy_Headshot.jpg",
    bio: "George helps agents and their clients cut through the noise of today's market with clear, plain-English lending education. His goal: turn complicated mortgage decisions into confident next steps.",
  },
  {
    name: "Claudia Gomez",
    title: "Loan Officer, American Pacific Mortgage",
    nmls: "NMLS #2298266",
    image:
      "https://customer-assets.emergentagent.com/job_realtor-learning-hub/artifacts/fonvbzau_claudie%20hs.jpg",
    bio: "Claudia believes that buying a home should be exciting — not confusing. She is committed to educating and guiding buyers every step of the way, helping them understand their options and achieve their homeownership goals.",
  },
];

export const VALUE_PROPS = [
  {
    icon: "ShieldCheck",
    title: "Build trust before the appointment",
    body: "When your clients learn directly from licensed loan officers, you become the agent who shows up with answers — not just listings.",
  },
  {
    icon: "TrendingUp",
    title: "Move fence-sitters forward",
    body: "Buyers waiting on rates or unsure they qualify get clarity in a low-pressure classroom — so they're ready when the right home appears.",
  },
  {
    icon: "Users",
    title: "Give your audience real value",
    body: "Invite your sphere to a free class and stay top-of-mind by educating instead of selling. Every session is content you can share.",
  },
  {
    icon: "Lightbulb",
    title: "Learn products you can share",
    body: "Down payment assistance, renovation loans, buydowns — know the tools that win deals and pass them on to your clients with confidence.",
  },
];

export const CLASS_TYPES = [
  {
    tag: "Every Week",
    title: "Weekly Classes",
    body: "Consistent, deep-dive sessions on the fundamentals — qualifying, pre-approval, credit, down payment programs, and the full path to the closing table. Perfect to invite clients to on repeat.",
    bullets: ["First-time buyer roadmap", "Credit & qualifying basics", "Loan program deep-dives"],
  },
  {
    tag: "Timely",
    title: "Hot Topic Classes",
    body: "Fast-moving market updates and special sessions reacting to rates, news, and what buyers are asking right now.",
    bullets: ["Rate & market updates", "Guest expert spotlights", "Seasonal opportunities"],
  },
];

export const SCHEDULE = [
  { day: "Every Tuesday", time: "6:30 PM ET", title: "Weekly Class: The Buyer's Roadmap", type: "Weekly" },
  { day: "Every Thursday", time: "1:00 PM ET", title: "Weekly Class: Loan Programs Demystified", type: "Weekly" },
  { day: "Bi-Weekly Friday", time: "11:00 AM ET", title: "Hot Topic: Market & Rate Pulse", type: "Hot Topic" },
  { day: "Monthly", time: "Time TBD", title: "Guest Spotlight: Special Industry Experts", type: "Guest" },
];

export const LEARN_ITEMS = [
  "How buyers qualify — including with 1099 / self-employed income",
  "Down payment assistance programs most people never hear about",
  "Credit basics: what actually moves the needle before applying",
  "Rate buydowns and how they lower a buyer's monthly payment",
  "Renovation loans to turn a 'needs work' listing into a dream home",
  "The full path from pre-approval to the closing table",
  "How agents can confidently answer client financing questions",
  "What's happening with rates and the market right now",
];

export const TESTIMONIALS = [
  {
    quote:
      "I invited three buyers who were 'just looking.' After one class they finally understood their options — two are now under contract. This is the easiest value I've ever given my clients.",
    name: "Marisol Reyes",
    role: "Real Estate Agent",
  },
  {
    quote:
      "George and Claudia explain things without the jargon. I went from nervous and confused about qualifying to actually excited to start house hunting.",
    name: "Daniel Brooks",
    role: "First-Time Buyer",
  },
  {
    quote:
      "I share the registration link with my whole database every week. It keeps me top-of-mind and positions me as the agent who actually educates instead of just selling.",
    name: "Tina Alvarez",
    role: "Broker Associate",
  },
];

export const FAQS = [
  {
    q: "Who should I invite to these classes?",
    a: "Real estate agents, their prospects, and clients who are on the fence about buying. Anyone curious about how lending works is welcome — the sessions are educational, never high-pressure sales.",
  },
  {
    q: "Is there any cost to attend?",
    a: "No. These classes are completely free. Our goal is to educate the community and help agents serve their clients better.",
  },
  {
    q: "How do I join after registering?",
    a: "Once you register, you'll receive a confirmation with the webinar link and a calendar invite. (Sessions are hosted via Zoho Webinar.)",
  },
  {
    q: "Can I invite guests to speak or suggest a topic?",
    a: "Absolutely. We regularly invite guest experts and cover hot topics requested by our community. Reach out after you register.",
  },
  {
    q: "I'm an agent — can I share these with my database?",
    a: "Yes, please do! That's exactly the point. Share the registration link with your sphere and let us help you build trust with your audience.",
  },
];
